import React, { Component } from "react";
import { connect } from "react-redux";
import { buildUrlFromParams } from "../../common/functions/url";
import { takeExcelFile } from "../../common/functions/excelExport";
import WithAjax from "../../common/helpers/WithAjax";
import Table from "../../../tables/reactable/DefaultTable";
import NewAdminMessageButton from "../../admin-messages/list/components/NewAdminMessageButton/NewAdminMessageButton";
import { capitalize } from "lodash";

class ProfileList extends Component {
  constructor() {
    super();

    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this);
    this.exportProfiles = this.exportProfiles.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onFilter = this.onFilter.bind(this);
    this.state = {
      itemsPerPage: 10,
      openBtnVisible: true,
      openBtnLabel: "View",
      search: "",
      filter: {
        ProfileTypeLabel: "",
      },
    };
  }

  onChangeItemsPerPage(e) {
    e.preventDefault();
    this.setState({
      itemsPerPage: e.target.value,
    });
    return false;
  }

  exportProfiles() {
    if (this.props.items.length < 1) {
      alert("No records to export.");
      return;
    }

    let url = buildUrlFromParams(this.props.urlExport, {
      noi18n: "true",
    });

    this.props.ajax.get(url, true, (data) => {
      takeExcelFile(data);
    });
  }

  onSearch(e) {
    e.preventDefault();
    this.setState({
      search: e.target.value,
    });
    return false;
  }

  onFilter(filter) {
    this.setState({
      filter: filter,
    });
  }

  render() {
    let items = this.props.items.map((item) => {
      return Object.assign({}, item, {
        AvatarImage: item.SkillVendorAvatarImageUrl ? <img src={item.SkillVendorAvatarImageUrl} style={{ width: "50px" }} className="rounded-circle" alt="" /> : null,
        StatusModifiedDate: <span statusmodifieddate={item.StatusModifiedDate}>{item.StatusModifiedDateAsString}</span>,
      });
    });

    let filteredItems = this.props.items
      ? this.props.items.filter((f) => !this.state.filter.ProfileTypeLabel || f.ProfileTypeLabel.toLowerCase() === this.state.filter.ProfileTypeLabel.toLowerCase())
      : [];
    return (
      <div>
        <Table
          items={items}
          columns={this.props.columns}
          columnNames={this.props.columnNames}
          itemsPerPage={this.props.itemsPerPage ? this.props.itemsPerPage : this.state.itemsPerPage}
          hiddenColumns={this.props.hiddenColumns}
          searchable={this.props.searchable}
          search={this.state.search}
          onSearch={this.onSearch}
          filterable={this.props.filterable}
          filter={this.state.filter}
          onFilter={this.onFilter}
          onChangeItemsPerPage={this.onChangeItemsPerPage}
          openBtnVisible={this.state.openBtnVisible}
          openBtnLabel={this.state.openBtnLabel}
          openBtnHref="/talents/{NavigationParam}/overview"
          sortable={this.props.tableSortDefinition}
          defaultSort={{ column: "StatusModifiedDate", direction: "desc" }}
          hiddenSelectItemsPerPage={this.props.hiddenSelectItemsPerPage ? this.props.hiddenSelectItemsPerPage : ""}
        />
        <div className="mt-3">
          {this.props.urlExport && (
            <button className="btn btn-primary btn-rounded" type="button" onClick={this.exportProfiles}>
              Export
            </button>
          )}

          {filteredItems && filteredItems.length > 0 && this.props.label && (
            <NewAdminMessageButton
              className="ml-2"
              skillVendorIds={filteredItems.map((m) => m.SkillVendorId)}
              history={this.props.history}
              recipients={`Talents > ${this.props.label} > ${this.state.filter.ProfileTypeLabel ? capitalize(this.state.filter.ProfileTypeLabel) : "All"} (${filteredItems.length})`}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({});
const mapDispatchToProps = (dispatch) => ({});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WithAjax(ProfileList));
